export const URL = "http://127.0.0.1:5000/search"
// export const URL = "https://search.the-syllabus.com/search"
export const MINIMUM_LENGTH_QUERY = 3
